import { ActionsDrop } from "components/actions-drop"
import { Button } from "components/Button/Button"
import { DataTable, TableCol } from "components/DataTable/DataTable"
import { DialogModal } from "components/dialog-modal/dialog-modal"
import { useLangContext } from "context/Lang"
import { LessonForm } from "forms/lesson-form"
import { Pencil, Plus } from "lucide-react"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { routes } from "routes"
import { AsyncProcess, AsyncProcessErrorProps } from "services/AsyncProcess"
import { setToast } from "storeRedux/slices/toast"




export const Lessons = () => {
    const { gW } = useLangContext();

    const [visibleDialog, setDialogVisible] = useState<{ data?: LessonType, title: string } | null>(null);



    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<AsyncProcessErrorProps | null>(null)
    const dispatch = useDispatch();
    const [lessons, setLessons] = useState<LessonType[]>([])

    const isEdit = !!visibleDialog?.data?.id



    const fetchLessons = async () => {
        setLoading(true)

        await AsyncProcess({
            type: "get",
            url: routes.api.lessons,
            setError: (err) => {
                dispatch(
                    setToast({
                        detail: gW(err?.error || "happen-error", err?.words),
                        severity: "error",
                    })
                )
            },
            effectProcess: [(data) => setLessons(data || [])],
        })

        setLoading(false)
    }

    useEffect(() => {
        fetchLessons()
    }, [])

    const handleSubmit = async (data: LessonType) => {
        setLoading(true)
        setError(null)

        const formData = new FormData()

        Object.entries(data).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                formData.append(key, value as any)
            }
        })

        await AsyncProcess({
            type: isEdit ? "put" : "post",
            url: isEdit
                ? `${routes.api.lessons}/${data.id}`
                : routes.api.lessons,
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
            code: isEdit ? 200 : 201,
            setError: (err) => {
                dispatch(setToast({ detail: gW(err?.error || "happen-error", err?.words), severity: "error" }));
            },
            effectProcess: [
                () => {
                    setDialogVisible(null) // close modal on success
                },
            ],
        })

        setLoading(false)
    }


    const columns: TableCol<LessonType>[] = [
        {
            label: gW("lesson-name"),
            name: "name",
        },
        {
            label: gW("description"),
            name: "description",
        },
        {
            label: gW("status"),
            cell: (lesson: LessonType) =>
                lesson.status ? (
                    <span className="text-green-600">{gW("active")}</span>
                ) : (
                    <span className="text-red-600">{gW("inactive")}</span>
                ),
        },
        {
            label: gW("select"),
            cell: (lesson: LessonType) => (
                <ActionsDrop
                    onEdit={() =>
                        setDialogVisible({
                            data: lesson,
                            title: gW("edit-lesson"),
                        })
                    }
                />
                // <Button
                //     size="sm"
                //     variant="outline"
                //     onClick={() =>
                //         setDialogVisible({
                //             data: lesson,
                //             title: gW("edit-lesson"),
                //         })
                //     }
                // >
                //     <Pencil className="w-4 h-4" />
                // </Button>
            ),
        },
    ]
    return <>

        <DialogModal
            title={visibleDialog?.title || ""}
            isOpen={visibleDialog !== null}
            onClose={() => { setDialogVisible(null) }}
        >
            <LessonForm
                loading={loading}
                lesson={visibleDialog?.data}
                onSubmit={handleSubmit}
            />

            {error && (
                <div className="mt-3 text-sm text-red-600">
                    {gW(error.error)}
                </div>
            )}

        </DialogModal>

        <Button disabled={loading} variant="outline" onClick={() => { setDialogVisible({ title: gW("new-lesson") }) }}  >
            <Plus />
            <span>  {gW("new-lesson")} </span>
        </Button>

        {/* <DataTable<LessonType>
            data={lessons}
            columns={columns}
            // rowKey={(lesson) => lesson.id||""}
            loading={loading}
        /> */}
    </>
}